import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const StarzEncore = () => (
  <div>
    <h2>Starz/Encore</h2>
    <p>13 Channels of Premium Starz/Encore Content in HD. $16</p>
    <Button outline color="success" id="starzencoretoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#starzencoretoggle">
      <Card>
        <CardBody>
          420 - Starz<br />
          422 - Starz Cinema<br />
          423 - Starz Comedy<br />
          424 - Starz Edge<br />
          425 - Starz in Black<br />
          426 - Starz Kids and Family<br />
          435 - Starz Encore<br />
          436 - Starz Encore Action<br />
          437 - Starz Encore Black<br />
          438 - Starz Encore Classic<br />
          439 - Starz Encore Suspense<br />
          440 - Starz Encore Family<br />
          441 - Starz Encore Westerns<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default StarzEncore;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/starzencore.js